import { ReactNode, Suspense, useCallback, useEffect, useRef, useState } from "react";
import { AppModalContext, AppModalContextType } from "./AppModalContext";
import { useLocation } from "react-router-dom";

export interface AppModalProviderProps {
  children: React.ReactNode;
}

export function AppModalProvider({ children }: AppModalProviderProps) {
  const [content, setContent] = useState<ReactNode | null>(null);

  const { pathname } = useLocation();

  const isOpenRef = useRef(!!content);
  isOpenRef.current = !!content;

  const onCloseModal = useCallback(() => setContent(null), []);

  const onOpenModal = useCallback((newContent: ReactNode) => setContent(newContent), []);

  useEffect(() => {
    if (isOpenRef.current) onCloseModal();
  }, [pathname, onCloseModal]);

  const value: AppModalContextType = {
    isOpen: !!content,
    onCloseModal,
    onOpenModal,
  };

  return (
    <AppModalContext value={value}>
      {children}
      <Suspense fallback={null}>{content}</Suspense>
    </AppModalContext>
  );
}
